(() => {
  'use strict';
  const config = window.MyMask || { root: '/', cart: '/cart', currency: 'EUR', locale: 'en' };
  const text = key => config.strings?.[key] || key;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  function money(cents, currency) {
    return new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: currency || config.currency || 'EUR' }).format(cents / 100);
  }
  function photo(variant, product) {
    const image = variant.featured_image;
    return (image && (image.src || image.url)) || product.featured_image || product.images?.[0] || '';
  }
  function designName(variant, product) {
    if (product.handle.includes('funny-face')) {
      const labels = { A: text('pack.teeth'), B: text('pack.grey'), C: text('pack.cigarette'), D: text('pack.moustache'), E: text('pack.alt') };
      return labels[variant.title] ? `${variant.title} — ${labels[variant.title]}` : variant.title;
    }
    return variant.title;
  }
  function initBuilder(builder) {
    if (builder.dataset.ready) return;
    builder.dataset.ready = 'true';
    let data;
    try { data = JSON.parse(builder.querySelector('[data-pack-data]').textContent); } catch (_) { return; }
    const products = data.products.filter(product => product && Array.isArray(product.variants));
    const choices = products.flatMap(product => product.variants.map(variant => ({ variant, product })));
    const available = choices.filter(choice => choice.variant.available);
    const first = available[0] || choices[0];
    if (!first) return;
    const requestedId = new URLSearchParams(window.location.search).get('variant');
    const requested = builder.dataset.context === 'product' && choices.find(choice => String(choice.variant.id) === requestedId);
    let selected = [requested || first];
    const slots = builder.querySelector('.pack-slots');
    const total = builder.querySelector('[data-pack-total]');
    const add = builder.querySelector('[data-add-pack]');
    const error = builder.querySelector('.pack-error');
    const addLabel = add.querySelector('[data-add-label]');
    function updatePhoto(choice, index) {
      const slot = slots.children[index];
      const img = slot.querySelector('img');
      img.src = photo(choice.variant, choice.product);
      img.alt = `${choice.product.title} — ${designName(choice.variant, choice.product)}`;
      slot.querySelector('.slot-price').textContent = money(choice.variant.price, data.currency);
      if (builder.dataset.context === 'product' && index === 0) {
        const main = document.querySelector('.main-product-image');
        if (main && img.src) { main.src = img.src; main.removeAttribute('srcset'); main.alt = img.alt; }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', choice.variant.id);
        history.replaceState({}, '', url);
        const price = document.querySelector('.product-price');
        if (price) { price.replaceChildren(document.createTextNode(money(choice.variant.price, data.currency) + ' ')); const per = document.createElement('span'); per.textContent = text('product.per'); price.append(per); }
      }
    }
    function updateTotal() {
      total.textContent = money(selected.reduce((sum, choice) => sum + choice.variant.price, 0), data.currency);
      add.disabled = selected.some(choice => !choice.variant.available);
      addLabel.textContent = add.disabled ? text('pack.unavailable') : text('pack.add') + ' · ' + selected.length;
      add.querySelector('.icon').toggleAttribute('hidden', add.disabled);
    }
    function renderSlots() {
      slots.replaceChildren();
      selected.forEach((choice, index) => {
        const slot = document.createElement('div'); slot.className = 'pack-slot';
        const img = document.createElement('img'); img.width = 72; img.height = 86;
        const field = document.createElement('div'); field.className = 'slot-field';
        const label = document.createElement('label');
        const id = `mask-design-${builder.closest('[id]')?.id || 'main'}-${index}`;
        label.htmlFor = id; label.textContent = `${text('pack.mask')} ${index + 1} — ${text('pack.choose')}`;
        const select = document.createElement('select'); select.id = id;
        products.forEach(product => {
          const group = document.createElement('optgroup'); group.label = product.title.split(' – ')[0];
          choices.filter(item => item.product.id === product.id).forEach(item => {
            const option = document.createElement('option'); option.value = String(item.variant.id);
            option.textContent = designName(item.variant, item.product) + (item.variant.available ? '' : ' — ' + text('pack.sold'));
            option.disabled = !item.variant.available; option.selected = item.variant.id === choice.variant.id;
            group.append(option);
          });
          select.append(group);
        });
        const price = document.createElement('span'); price.className = 'slot-price';
        field.append(label, select, price); slot.append(img, field); slots.append(slot);
        select.addEventListener('change', () => {
          selected[index] = choices.find(item => String(item.variant.id) === select.value);
          error.hidden = true; updatePhoto(selected[index], index); updateTotal();
        });
        updatePhoto(choice, index);
      });
      updateTotal();
    }
    builder.querySelectorAll('.pack-sizes input').forEach(input => input.addEventListener('change', () => {
      const count = Number(input.value);
      selected = Array.from({ length: count }, (_, index) => selected[index] || available[index % Math.max(1, available.length)] || first);
      error.hidden = true; renderSlots();
    }));
    add.addEventListener('click', async () => {
      if (add.disabled) return;
      add.disabled = true; add.setAttribute('aria-busy', 'true'); addLabel.textContent = text('pack.adding'); error.hidden = true;
      const quantities = new Map();
      selected.forEach(({ variant }) => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [...quantities].map(([id, quantity]) => ({ id, quantity })) })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : text('pack.error'));
        window.location.assign(config.cart);
      } catch (err) {
        error.textContent = err.message || text('pack.error'); error.hidden = false;
        error.tabIndex = -1; error.focus(); add.removeAttribute('aria-busy'); updateTotal();
      }
    });
    renderSlots();
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-pack-builder]').forEach(initBuilder);
    scope.querySelectorAll('.gallery-thumb').forEach(button => {
      if (button.dataset.ready) return; button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const main = document.querySelector('.main-product-image');
        if (main) { main.src = button.dataset.image; main.removeAttribute('srcset'); main.alt = button.dataset.alt; }
        scope.querySelectorAll('.gallery-thumb').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  }
  document.querySelectorAll('.mobile-nav a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach(menu => menu.removeAttribute('open')); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
